import React, { useEffect, useState } from 'react';
import { IconButton, Tooltip, Typography } from '@material-ui/core';
import LogoutIcon from '@mui/icons-material/Logout';
import { useHistory } from "react-router-dom";
import { logout } from '../../../redux/actions/auth';
import { connect } from 'react-redux';
import { PauseCircleOutline } from '@material-ui/icons';
import { Avatar, Modal } from '@mui/material';
import PlayArrow from '@material-ui/icons/PlayArrow';
import { Box } from '@mui/system';
import { soundSettings } from '../../../redux/actions/settings';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'white',
    borderRadius: "50%",
    boxShadow: 24,
    outline: 'none',
    p: 4,
    overflow: 'hidden',
};

function PauseMenu({ toggleAudio, analysis, togglePlay, playerType, isSpacebarClicked, firstSpacebarPressed, resumeStory, recordingText, pageVisible, isSettingsMenuOpen, modalState, dispatch, modalIsOpen }) {

    const [open, setOpen] = useState(false);
    const handleClose = () => {
        setOpen(false);
        if (!playerType) {
            toggleAudio(analysis);
        }
    }

    const history = useHistory();

    useEffect(() => {
        if (isSettingsMenuOpen) {
            setOpen(false);
        }

        if (!playerType) {
            if (open && togglePlay) {
                setOpen(false);
            }
            if (!pageVisible && togglePlay) {
                handleClick();
            }
        } else if (!pageVisible && !togglePlay) {
            handleClick();
        }
    }, [open, playerType, togglePlay, pageVisible, isSettingsMenuOpen])

    useEffect(() => {
        if (firstSpacebarPressed) {
            if (open) {
                resumeStory();
            } else {
                toggleAudio(analysis);
            }
            setOpen(!open);
        }
    }, [firstSpacebarPressed, isSpacebarClicked])

    const handleClick = (event) => {
        console.log('pause menu open called');
        if (modalState && !modalState.isQuestionClicked) {
            toggleAudio(analysis);
            setOpen(true);
        }
    };

    const handleLogout = () => {
        document.body.style.background = "#ddf0ff";

        //clearing local storage keys
        localStorage.setItem(`review_done`, "false");
        let keysToRemove = ["logged_user", "reporting_time", "book_id", "current_section"];

        for (let key of keysToRemove) {
            localStorage.removeItem(key);
        }

        dispatch(logout());
        window.getStoryCalled = false;
        window.getSavedSessionCalled = false;
        window.getSettingsCalled = false;
        setTimeout(() => {
            history.push("/");
        }, 500);
    }

    const handleSoundSettingsModal = () => {
        dispatch(soundSettings(true));
    }

    return (
        <div>
            <IconButton onClick={handleClick} size="small" sx={{ ml: 2 }}>
                <Avatar sx={{ width: 32, height: 32 }}>
                    <PauseCircleOutline
                        style={{ cursor: "pointer", fontSize: 32 }}
                    />
                </Avatar>
            </IconButton>
            <Modal
                open={open || modalIsOpen}
                //onClose={playerType ? handleClick : handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div className="pause_menu">
                        {recordingText &&
                            <h3 style={{ textAlign: 'center' }}>{recordingText}</h3>
                        }
                        <ul id="modal-modal-title" className="pause_menu_item">
                            {recordingText &&
                                <li className="pause_menu_list" onClick={handleSoundSettingsModal}>
                                    <Tooltip title="Sound Settings" arrow>
                                        <span>Sound Settings</span>
                                    </Tooltip>
                                </li>
                            }
                            {
                                modalIsOpen &&
                                <Typography variant='h5'>Something went wrong ! </Typography>
                            }
                            {!modalIsOpen &&
                                <li className="pause_menu_list" onClick={resumeStory}>
                                    <Tooltip title="Resume" arrow>
                                        <IconButton
                                            variant="contained"
                                        >
                                            <PlayArrow className='play_icon' />
                                        </IconButton>
                                    </Tooltip>
                                    <span>Resume</span>
                                </li>
                            }
                            <li className="pause_menu_list" onClick={handleLogout}>
                                <Tooltip title="Logout" arrow>
                                    <IconButton
                                        variant="contained"
                                        color="secondary"
                                    >
                                        <LogoutIcon className='logout_icon' />
                                    </IconButton>
                                </Tooltip>
                                <span>Logout</span>
                            </li>
                        </ul>
                    </div>
                </Box>
            </Modal>
        </div >
    )
}

const mapState = ({ platform: { settings: { isSettingsMenuOpen, modalState } } }) => {
    return {
        isSettingsMenuOpen,
        modalState
    }
};

export default connect(mapState)(PauseMenu);
